import React from "react";
import { visuallyHiddenStyle } from "../../../theme/accessibility";
import { isPropValid, styled } from "../../../theme/styled/styled";
import { font } from "../../typography/baseStyling";

interface CheckboxGroupProps {
  label: string;
  /* Use this to connect another label to the checkbox group, if you use this leave `label` prop as an empty string. */
  labelAsAriaLabelledby?: string;
  /** Hides the label visually but keeps it for screen readers */
  hideLabelVisually?: boolean;
  children: React.ReactElement[] | React.ReactElement;
  className?: string;
}

export const CheckboxGroup = ({
  label,
  labelAsAriaLabelledby,
  hideLabelVisually,
  children,
  className,
}: CheckboxGroupProps): React.JSX.Element => {
  return (
    <Group className={className}>
      <LegendLabel
        hide={hideLabelVisually}
        aria-labelledby={labelAsAriaLabelledby}
      >
        {label}
      </LegendLabel>
      {children}
    </Group>
  );
};

const Group = styled.fieldset({
  display: "flex",
  flexWrap: "wrap",
  gap: "$spacing-8",
  flexDirection: "column",
  border: 0,
  margin: 0,
  padding: 0,
});

const LegendLabel = styled("legend", {
  forwardProp: (prop) => isPropValid(prop) && prop !== "hide",
})<{
  hide: CheckboxGroupProps["hideLabelVisually"];
}>(({ hide }) => {
  const style = {
    color: "$text-primary",
    marginBottom: "$spacing-8",
    ...font.BodyM,
  } as const;

  return hide ? visuallyHiddenStyle : style;
});
